import React from 'react';

import _ from 'lodash';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import { formSelect as Select } from 'shared/forms/RenderSelect';

import { fetchCities } from './ducks';

class CityField extends React.Component {
  componentDidMount() {
    this.props.fetchCities();
  }

  handleInputChange = value => {
    const { fetchCities } = this.props;

    fetchCities({ name: value });
  };

  render() {
    const { name, className, validate, options, placeholder } = this.props;

    return (
      <Field
        name={name}
        className={className}
        validate={validate}
        component={Select}
        options={options}
        placeholder={placeholder}
        onInputChange={_.debounce(this.handleInputChange, 300)}
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { options } = state.shared.cityField;

  return { options };
};

const mapDispatchToProps = {
  fetchCities
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CityField);
